import { Dropdown } from "@fluentui/react/lib/Dropdown";
import { MessageBar, MessageBarType } from "@fluentui/react/lib/MessageBar";
import { Stack } from "@fluentui/react/lib/Stack";

import { WithTheme } from "Components/Generic/Theme/WithTheme";
import { CurrencyPosition, getCurrencySymbol } from "Utils/Number";
import { EditNumber } from "../EditNumber/EditNumber";
import { IEditFieldProps } from "../IEditFieldProps";
import { useEditMoney } from "./UseEditMoney";

export const EditMoney = WithTheme((props: IEditFieldProps): JSX.Element => {
  const {
    fieldName,
    translator,
    disabled,
    theme: { spacing }
  } = props;
  const activeLocale = translator.getActiveLocale();
  const {
    currencyOptions, currencyPosition, fallback, onChangeCurrency, selectedCurrency, showFallback
  } = useEditMoney(props);
  return (
    <Stack tokens={{ childrenGap: spacing.s1 }}>
      {showFallback
        ? (
          <Stack.Item>
            <MessageBar messageBarType={MessageBarType.warning}>
              {`${fallback} (${translator.get(
                `edit.transfervalues`,
                `Please transfer the values into the fields below.`
              )})`}
            </MessageBar>
          </Stack.Item>
        )
        : null}
      <Stack horizontal tokens={{ childrenGap: spacing.s2 }}>
        <Stack.Item grow>
          <EditNumber
            {...{
              ...props,
              fieldName,
              prefix:
                currencyPosition === CurrencyPosition.Front
                  ? getCurrencySymbol(activeLocale, selectedCurrency)
                  : undefined,
              suffix:
                currencyPosition === CurrencyPosition.Back
                  ? getCurrencySymbol(activeLocale, selectedCurrency)
                  : undefined
            }}
          />
        </Stack.Item>
        <Stack.Item disableShrink style={{ width: `85px` }}>
          <Dropdown
            options={currencyOptions}
            selectedKey={selectedCurrency}
            onChange={onChangeCurrency}
            disabled={disabled}
          />
        </Stack.Item>
      </Stack>
    </Stack>
  );
});
